const defaultState = false;

export default (state = defaultState, action) => {
    const { type } = action;

    switch (type) {
        case "isBlurry/setBlurry":
            return true;
        case "isBlurry/clear":
        case "REDUX/CLEAR":
            return defaultState;
        default:
            return state;
    }
};